export enum PropertyApprovalStatus {
  Approved = 'Approved',
  AutoApproved = 'AutoApproved',
  Rejected = 'Rejected',
  UnderManualReview= 'UnderManualReview'
}